import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/cash-flow-setups';

export default coreStore.createCoreStore('cashflowSetup', remoteResource);
